<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Permissão do Usuario'"
      :newRowmodalButtonText="'Nova permissão'"
      :tableHeader="headers"
      :tableRows="permissao"
      :isEdit="true"
      :isFinish="false"
      :isDel="true"
      :isPrint="false"
      v-on:datatable-newrow="onDataTableInsertRow"
      v-on:datatable-updaterow="onDataTableUpdateRow"
      v-on:datatable-deleterow="onDataTableDeleteRow"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <ModalCustomSize
      :modalSize="modalCustomSizeData.modalSize"
      :isTheModalOpen="modalCustomSizeData.isOpen"
      :modalButtonText="modalCustomSizeData.buttonText"
      :modalFormTitle="modalCustomSizeData.formTitle"
      :modalType="modalCustomSizeData.modalType"
      :isLoadingRequestDisable="modalCustomSizeData.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSizeData.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSizeData.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSizeData.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-col cols="12">
        <AlertasModal
          :tipo="alertaModal.tipo"
          :texto="alertaModal.texto"
        ></AlertasModal>
      </v-col>
      <v-form v-model="estaValido">
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.nomePermissao"
              name="nomePermissao"
              label="Nome"
              autocomplete="off"
              :rules="[rules.requerido]"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSizeData.actualEdit.descricaoPermissao"
              name="descricaoPermissao"
              label="Descrição"
              autocomplete="off"
              :rules="[rules.requerido]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </ModalCustomSize>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";

export default {
  components: {
    DataTable,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal,
  },

  data: () => ({
    rules: {
      requerido: (value) => !!value || "Requer o campo!",
      email: (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Formato de E-mail inválido.",
    },
    estaValido: false,
    newNotify: {
      isNewNotify: false,
      text: "",
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    showSkeletonTable: true,

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID",
        value: "numeroPermissao",
      },
      {
        text: "Nome",
        value: "nomePermissao",
      },
      {
        text: "Descrição",
        value: "descricaoPermissao",
      },
      { text: "Atualizar/Excluir", value: "actions", sortable: false },
    ],

    modalCustomSizeData: {
      modalSize: "1100",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroPermissao: null,
        nomePermissao: null,
        descricaoPermissao: null,
        descricaoTela: "permissao",
      },
    },

    //Array populado pela função initialize
    permissao: [],
  }),

  created() {
    this.initialize();
  },

  watch:{
    estaValido() {
      this.modalCustomSizeData.isButtonsDisabled = !this.estaValido
    }
  },

  methods: {
    /****************************************************************
     *                 FUNÇÕES DE EVENTO
     **************************************************************** */

    onDataTableInsertRow() {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.modalCustomSizeData.isOpen = true;
      this.modalCustomSizeData.isEdit = false;
      this.modalCustomSizeData.buttonText = "Registrar";
      this.modalCustomSizeData.formTitle = "Nova permissão";

      this.modalCustomSizeData.actualEdit.numeroPermissao = null;
      this.modalCustomSizeData.actualEdit.nomePermissao = null;
      this.modalCustomSizeData.actualEdit.descricaoPermissao = null;
    },

    onDataTableUpdateRow(item) {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.modalCustomSizeData.isOpen = true;
      this.modalCustomSizeData.isEdit = true;
      this.modalCustomSizeData.buttonText = "Salvar";
      this.modalCustomSizeData.formTitle = "Atualizar Permissão do Usuario";

      this.modalCustomSizeData.actualEdit.numeroPermissao =
        item.numeroPermissao;
      this.modalCustomSizeData.actualEdit.nomePermissao = item.nomePermissao;
      this.modalCustomSizeData.actualEdit.descricaoPermissao =
        item.descricaoPermissao;
    },

    async onDataTableDeleteRow(item) {
      try {
        await this.delete(item);
      } catch (error) {
        console.log(error);
      } finally {
        await this._listarPermissao();
        this.modalCustomSizeData.isLoadingRequestDisable = true;
      }
    },

    async onFormModalAction() {
      try {
        this.modalCustomSizeData.isButtonsDisabled = true;
        if (this.modalCustomSizeData.isEdit) {
          await this.update(this.modalCustomSizeData.actualEdit);
        } else {
          await this.insert(this.modalCustomSizeData.actualEdit);
        }
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        await this._listarPermissao();
        this.modalCustomSizeData.isButtonsDisabled = false;
        this.modalCustomSizeData.isOpen = false;
      }
    },

    /****************************************************************
     *                 FUNÇÕES DO COMPONENTE
     **************************************************************** */

    fecharNotificacao() {
      this.newNotify.isNewNotify = false;
    },

    async _listarPermissao() {
      try {
        const response = await axios.get("permissao", this.config);
        this.showSkeletonTable = false;
        this.permissao = response.data;
      } catch (error) {
        console.log(error.response);
      }
    },

    async initialize() {
      try {
        await this._listarPermissao();
      } catch (error) {
        console.log(error.response);
      }
    },

    async insert(reciveItem) {
      try {
        this.alertaModal.tipo = null;
        this.modalCustomSizeData.isLoadingRequestDisable = true;

        await axios.post("permissao", reciveItem, this.config);
        this.$socket.emit("insertLog");
        
        this.alerta.texto = "Permissão adicionada com sucesso!"
        this.alerta.tipo = 'sucesso';

        this.modalCustomSizeData.isLoadingRequestDisable = false;
        return true;
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
      }
    },

    async update(reciveItem) {
      try {
        this.alertaModal.tipo = null;
        this.modalCustomSizeData.isLoadingRequestDisable = true;

        await axios.put("permissao", reciveItem, this.config);
        // this.$socket.emit("update", reciveItem);
        this.$socket.emit("insertLog");

        this.alerta.texto = "Permissão atualizada com sucesso!";
        this.alerta.tipo = "sucesso";
        
        this.modalCustomSizeData.isLoadingRequestDisable = false;
        return true;
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
      }
    },

    async delete(reciveItem) {
      try {
        this.modalCustomSizeData.isLoadingRequestDisable = true;

        if (confirm("Você realmente deseja excluir este Permissao?")) {
          reciveItem.descricaoTela = "permissao";

          await axios.delete("permissao", {
            data: reciveItem,
            headers: this.config.headers,
          });
          // this.$socket.emit("delete", reciveItem);
          this.$socket.emit("insertLog");

          this.alerta.texto = "Permissão removida";
          this.alerta.tipo = "sucesso";
          
          return true;
        }
        this.modalCustomSizeData.isLoadingRequestDisable = false;
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSizeData.isLoadingRequestDisable = false;
      }
    },
  },
};
</script>
